/**
 * Firebase Firestore Module
 * Proporciona acceso a la base de datos y utilidades de Firestore.
 * Exporta: getDb(), serverTimestamp, converters.
 */

import { getFirestore, serverTimestamp as _serverTimestamp } from 'firebase/firestore';
import { app } from './app.js';

/**
 * Obtiene la instancia de Firestore
 * @returns {import('firebase/firestore').Firestore}
 */
export const getDb = () => getFirestore(app);

/**
 * Timestamp del servidor para registros de fecha
 * Útil para createdAt, updatedAt sin depender del reloj del cliente
 */
export const serverTimestamp = _serverTimestamp;

/**
 * Converters para transformar datos entre Firestore y la app
 * Permiten tipado fuerte y normalización de datos
 */
export const converters = {
  /**
   * Converter genérico para documentos con createdAt y updatedAt
   */
  withTimestamps: {
    toFirestore: (data) => ({
      ...data,
      updatedAt: _serverTimestamp()
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return {
        id: snapshot.id,
        ...data,
        // Convertir timestamps a Date si existen
        createdAt: data.createdAt?.toDate?.() || data.createdAt,
        updatedAt: data.updatedAt?.toDate?.() || data.updatedAt
      };
    }
  }
};

// Exportar db como alias para compatibilidad con código existente
export const db = getDb();
